jQuery(document).ready(function($) {
  
  function stickyHeader() {
    var st = $('body').scrollTop();

    if ( window.innerWidth > 768) {
      if (st > 66) {
        $('.nata-header_bottom').addClass('nata-header_sticky');
        $('.float-nav').attr('style','padding-top: 70px;');
      }
      if (st < 60) {
        $('.float-nav').attr('style','padding-top: 20px;');
      }
      if(st === 0) {
        $('.nata-header_bottom').removeClass('nata-header_sticky');
      }
    }
  }

  stickyHeader();

  $('.nata-header_menu__more').click(function() {
    $('.nata-header_menu-column').toggleClass('active');
    $(this).toggleClass('active');
		
  });
  $('.nata-header_burger').click(function() {
    $('.nata-header_close').toggleClass('active');
    $(this).toggleClass('active');
    $('.nata-header_mob').toggleClass('active');
  });

  $('.nata-header_close').click(function() {
    $('.nata-header_burger').toggleClass('active');
    $(this).toggleClass('active');
    $('.nata-header_mob').toggleClass('active');
  });

  var height = $('.section-related').height();
  $('.float-nav_container').attr('style', 'padding-bottom:' + (height + 120) + 'px!important');

  var links = [];

  $('.float-nav li a').each(function() {
    var link = $(this).attr('href');
    links.push(link);
    // var position = $(link).offset();
    // console.log(position.top + '----' + link);
  });
  
  $('body').scroll(function() {

    for(var i=0;i<=links.length;i++) {
      
      if ($(links[i]).visible(true)) {
        var position = $(links[i]).offset();
       
        if(position.top <= 0 && position.top >= -250) {
          $('.float-nav li').removeClass('active');
          $('.float-nav li:eq('+(i+1)+')').addClass('active');
        }
      }
    }

    stickyHeader();

  });
 
  $('.float-nav li').click(function() {
    // $('.float-nav li').removeClass('activeClick');
    $('.float-nav li').removeClass('active');
    $(this).addClass('active');
    setTimeout(function() {
      var st = $('body').scrollTop();
      $('html, body').animate({
        scrollTop: st - 65
      }, 1000);
    }, 500);
   
  });

  if ( window.innerWidth < 768) {
    $('body').addClass('fixed-nata-header');
    $('.nata-header').addClass('nata-header_sticky');
  }
  
});
